import logoUrl from '@/assets/ramp-logo.svg'

/**
 * Shown after sign-in when the account's Ramp AI (aiAgents) feature flag is
 * off — the add-in is unusable without it, so block with guidance instead of
 * surfacing 403s from every AI endpoint.
 */
export function AiDisabledScreen({ onSignOut }: { onSignOut: () => void }) {
  return (
    <div className='ramp-login'>
      <div className='ramp-login-card'>
        <img className='ramp-login-logo' src={logoUrl} alt='ramp' />
        <h3 className='ramp-login-header'>Ramp AI is not enabled</h3>
        <p className='ramp-login-tagline'>
          Ramp AI has not been enabled in your account. Please reach out to your account admin.
        </p>
        <div className='ramp-login-actions'>
          <button type='button' className='ramp-login-link' onClick={onSignOut}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  )
}
